import { Deserializable } from '../protocols/deserializable';
import { MonthlyPensionAccountSplitReasonAvailability } from './monthly-pension-account-split-reason-availability';

export class MonthlyPensionAccountPaymentInstructionAvailableActions implements Deserializable {
  public canAct!: boolean;
  public canSplit!: boolean;
  public canSuspend!: boolean;
  public canResume!: boolean;
  public canTerminate!: boolean;
  public splitReasons!: MonthlyPensionAccountSplitReasonAvailability[];

  public onDeserialize(): void {
    this.splitReasons = window.injector.Deserialize.arrayOf(
      MonthlyPensionAccountSplitReasonAvailability,
      this.splitReasons ?? []
    );
  }
}
